import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';

import { email, required, number, positiveNumber } from '../../../forms';

export const LabeledInput = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </InputGroup>
);
const RenderSelectInput = ({
  input,
  options,
  name,
  id,
  label,
  help,
  placeholder,
  meta: { active, touched, error, warning },
}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={value => {
        const values = value.map(v => v.value);
        input.onChange(values);
      }}
      onBlur={value => input.onBlur(value.value)}
      multi
      joinValues
      placeholder={placeholder}
    />
    {help && <HelpBlock>{help}</HelpBlock>}
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);

const ProposalSendForm = ({ onSubmit, initialValues, options }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if (!Array.isArray(values.contacts) || !values.contacts.length) {
        if (!values.email) {
          errors.FORM_ERROR = 'Enter an email or select a contact.';
        }
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            label="To"
            name="contacts"
            component={RenderSelectInput}
            options={options}
            placeholder="Select previously added contact for this brand"
          />
        </FormGroup>
        <p>Or invite a new person to respond to your hotel requests.</p>
        <FormGroup>
          <Field name="name" component={LabeledInput} label="Name" placeholder="Contact Name" />
          <Field
            name="email"
            component={LabeledInput}
            label="Email"
            placeholder="email@example.com"
            validate={email}
          />
        </FormGroup>
        {errors.FORM_ERROR && <p className="alert alert-danger">{errors.FORM_ERROR}</p>}
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={Object.keys(errors).length !== 0 || submitting}
              bsStyle="success"
              type="submit"
            >
              <i className="fa fa-envelope fa-lg" /> Send
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    )}
  />
);

export default ProposalSendForm;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalSendForm.js